<template>
  <div
    :class="[
      'styled-html',
      '*:not-last:mb-4',
      '[&_:is(h1,h2,h3,h4,h5,h6)]:not-first:mt-8',
      '[&_ol]:list-decimal [&_ol]:pl-6',
      '[&_ul]:flex [&_ul]:list-disc [&_ul]:flex-col [&_ul]:gap-4 [&_ul]:pl-ch',
      '[&_ul_li]:pl-ch',
      '[&_ul_li::marker]:text-primary-900',
      '[&_a]:font-medium [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2',
      '[&_blockquote]:border-l-4 [&_blockquote]:border-grey-300 [&_blockquote]:pl-4',
      '[&_blockquote]:text-grey-600 [&_blockquote]:italic',
      '[&_code]:rounded [&_code]:bg-grey-100 [&_code]:px-1.5 [&_code]:py-0.5',
      '[&_code]:font-mono [&_code]:em-text-sm',
      '[&_del]:line-through',
      '[&_em]:italic',
      '[&_h1]:text-3xl',
      '[&_:is(h2,h3,h4)]:text-xl',
      '[&_:is(h5,h6)]:text-sm',
      '[&_:is(h1,h2,h3,h4,h5,h6)]:font-bold',
      '[&_:is(h1,h2,h3,h4,h5,h6)]:text-primary-900',
      '[&_hr]:my-6 [&_hr]:border-grey-300',
      '[&_img]:h-auto [&_img]:max-w-full [&_img]:rounded',
      '[&_input[type=checkbox]]:mr-2 [&_input[type=checkbox]]:align-middle',
      '[&_p:not(:last-child)]:mb-4',
      '[&_pre]:overflow-x-auto [&_pre]:rounded [&_pre]:bg-primary-900',
      '[&_pre]:p-4 [&_pre]:text-white',
      '[&_pre_code]:bg-transparent [&_pre_code]:p-0 [&_pre_code]:text-inherit',
      '[&_strong]:font-bold',
      '[&_table]:w-full [&_table]:border-collapse',
      '[&_td]:border [&_td]:border-grey-300 [&_td]:px-3 [&_td]:py-2',
      '[&_th]:border [&_th]:border-grey-300 [&_th]:bg-grey-100',
      '[&_th]:px-3 [&_th]:py-2 [&_th]:text-left [&_th]:font-bold',
    ]"
  >
    <slot></slot>
  </div>
</template>
